import { Form } from '@mairistem/composants';
import dayjs from 'dayjs';

import { formatMonetaire } from '@/utils';

interface ChequeVacancesProps {
  dateValidite: string;
  nombre: number;
  montantUnitaire: number;
}

const ChequeVacances = (props: ChequeVacancesProps) => {
  const {
    dateValidite: dateProps,
    nombre: nombreProps,
    montantUnitaire: montantUnitaireProps,
  } = props;

  return (
    <Form.Group style={{ margin: 0, flex: 1 }}>
      <Form.Field inline width={2}>
        <label>Chèque vacances</label>
      </Form.Field>
      <Form.Field inline width={3}>
        Date de validité
        {' : '}
        <label>{dayjs(dateProps).format('DD/MM/YYYY')}</label>
      </Form.Field>
      <Form.Field inline width={2}>
        Nombre
        {' : '}
        <label>{nombreProps}</label>
      </Form.Field>
      <Form.Field inline width={3}>
        Montant unitaire
        {' : '}
        <label>{formatMonetaire(montantUnitaireProps, 2)}</label>
      </Form.Field>
      <Form.Field
        inline
        width={6}
        // @ts-expect-error
        style={{ textAlign: 'right' }}
      >
        Montant
        {' : '}
        <label>{formatMonetaire(nombreProps * montantUnitaireProps, 2)}</label>
      </Form.Field>
    </Form.Group>
  );
};

export default ChequeVacances;
